import { combineReducers } from "redux";

import publicReducer from "./publicReducer/reducer";
import cartReducer from "./cartReducer/reducer";
import orderAIReducer from "./orderAIReducer/reducer";
import rubyOrderReducer from "./rubyOrderReducer/reducer";

const rootReducer = (state, action, history) => {
  const allReducers = combineReducers({
    public: publicReducer,
    cart: cartReducer,
    orderAI: orderAIReducer,
    rubyOrder: rubyOrderReducer,
  });

  return allReducers(state, action);
};

export default rootReducer;
